import LocalStorage from './LocalStorage'


export default new LocalStorage()
